import React, { createContext, useContext } from "react";

const ToastContext = createContext(null);

/**
 * Toast Provider Component
 * Provides toast functionality throughout the app
 * Accepts toast implementation and Toaster component as props for flexibility
 */
export const ToastProvider = ({ children, useToast, Toaster }) => {
  // Use provided toast hook or create a default one
  const defaultToast = () => ({
    toast: (message, options) => console.log("Toast:", message, options),
    success: (message, options) => console.log("Success:", message, options),
    error: (message, options) => console.error("Error:", message, options),
    info: (message, options) => console.info("Info:", message, options),
    warning: (message, options) => console.warn("Warning:", message, options),
  });
  const useToastHook = useToast || defaultToast;
  const toast = useToastHook();

  return (
    <ToastContext.Provider value={toast}>
      {children}
      {Toaster && <Toaster />}
    </ToastContext.Provider>
  );
};

/**
 * Hook to use toast context
 */
export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToastContext must be used within a ToastProvider");
  }
  return context;
};

export default ToastProvider;
